<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey, cardMethodsKey } from "@/components/StickyNote/injectKeys";
import TeamSelector from "@/components/StickyNote/internal/TeamSelector/TeamSelector.vue";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import type { Team } from "@/model/session";
import { useServerSettingsStore } from "@/store/serverSettings";
import { NO_TEAM, useTeamStore } from "@/store/team";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);
const cardMethods = injectStrict(cardMethodsKey);

const serverSettingsStore = useServerSettingsStore();

// Get the team the card is currently assigned to
const selectedTeam = computed(() => {
  const teamId = card.teamId;
  return teamId ? useTeamStore().findTeam({ id: teamId }) : undefined;
});

// Assign the card to the given team
const handleTeamSelect = (team: Team | null) => {
  cardActions.setTeam("action-menu", card.id, team?.id || NO_TEAM.id);

  if (team?.id && serverSettingsStore.mirrorAssignedBacklogStickiesToTeamBoard) {
    void cardMethods.animate?.("mirroring");
  }

  dropdown.close();
};
</script>

<template>
  <TeamSelector
    :title="$t('action.team')"
    show-clear
    show-current-team
    :selected="selectedTeam"
    @select="handleTeamSelect"
  />
</template>
